import { createJSONStorage, persist } from 'zustand/middleware'
import { createWithEqualityFn as create } from 'zustand/traditional'

export interface SidebarStore {
  isExpanded: boolean
  toggleSidebar: () => void
}

export const useSidebarStore = create(
  persist<SidebarStore>(
    (set, get) => ({
      isExpanded: false,
      toggleSidebar: () => set({ isExpanded: !get().isExpanded }),
    }),
    {
      name: 'sidebar-state',
      storage: createJSONStorage(() => localStorage),
    },
  ),
)
